export default __webpack_public_path__ + "images/a4dc9ef22af3b965c42ee738c8b221e7-4_4K_1920x544.jpg";